/**
 * 各タブの一覧の絞り込み (表の上の開閉式) の開閉を覚えるキー。 通常入札・ブロック入札・約定結果・
 * オペレーション履歴の 4 タブで 1 つにし、 タブを替えても開閉が変わらないようにする
 * (UI 辞書 toolbar-collapsible.md「スポット市場・一覧」 の「開閉の状態は 4 タブで 1 つ」)。
 */
export const SPOT_LIST_FILTER_STORAGE_KEY = 'spotBidList'
